import { render, staticRenderFns } from "./ProductDetailPanel.vue?vue&type=template&id=47b0d700&scoped=true&"
import script from "./ProductDetailPanel.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailPanel.vue?vue&type=style&index=0&id=47b0d700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0d700",
  null
  
)

export default component.exports